<template>
  <div>
    <search-agent-statistics
      @submit="submitSearch"
      :agent-id="agentId"
    />

    <div class="simiot-table-operation-buttons">
      <a-space>
        <a-button type="primary" @click="exportData" style="display: none;">导出</a-button>
      </a-space>
    </div>

    <a-table
      size="middle"
      :scroll="{ x: 'max-content' }"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      @change="sortChange"
      row-key="id"
    >
      <div slot="name" slot-scope="name, record">
        <a-tooltip color="#FFFFFF">
          <template slot="title">
            <order-monthly-inc-chart
              style="height: 200px; width: 1000px;"
              :id="record.id"
            />
          </template>
          <div v-if="isShowMenu('agents/show')">
            <router-link :to="'/agents/' + record.agent_id + '/info'"> {{ name }} </router-link>
          </div>
          <div v-else>{{ name }}</div>
        </a-tooltip>
      </div>

      <div slot="totalOrder" slot-scope="total_order, record">
        <a-tooltip>
          <template slot="title">
            <div>采购订单：{{ record.purchased_order }} 个</div>
            <div>激活订单：{{ record.actived_order }} 个</div>
            <div>续期订单：{{ record.renewed_order }} 个</div>
            <div>套餐订购订单：{{ record.subscribed_order }} 个</div>
            <div>停机保号订单：{{ record.stopped_order }} 个</div>
            <div>流量使用订单：{{ record.card_used_order }} 个</div>
          </template>
          <div class="tip-item">
            {{ total_order }}
          </div>
        </a-tooltip>
      </div>

      <div slot="totalOrderInc1" slot-scope="total_order_inc1, record">
        <a-tooltip>
          <template slot="title">
            <div>采购订单：{{ record.purchased_order_inc1 }} 个</div>
            <div>激活订单：{{ record.actived_order_inc1 }} 个</div>
            <div>续期订单：{{ record.renewed_order_inc1 }} 个</div>
            <div>套餐订购订单：{{ record.subscribed_order_inc1 }} 个</div>
            <div>停机保号订单：{{ record.stopped_order_inc1 }} 个</div>
            <div>流量使用订单：{{ record.card_used_order_inc1 }} 个</div>
          </template>
          <div class="tip-item">
            {{ total_order_inc1 }}
          </div>
        </a-tooltip>
      </div>

      <div slot="totalOrderInc3" slot-scope="total_order_inc3, record">
        <a-tooltip>
          <template slot="title">
            <div>采购订单：{{ record.purchased_order_inc3 }} 个</div>
            <div>激活订单：{{ record.actived_order_inc3 }} 个</div>
            <div>续期订单：{{ record.renewed_order_inc3 }} 个</div>
            <div>套餐订购订单：{{ record.subscribed_order_inc3 }} 个</div>
            <div>停机保号订单：{{ record.stopped_order_inc3 }} 个</div>
            <div>流量使用订单：{{ record.card_used_order_inc3 }} 个</div>
          </template>
          <div class="tip-item">
            {{ total_order_inc3 }}
          </div>
        </a-tooltip>
      </div>

      <div slot="totalOrderInc6" slot-scope="total_order_inc6, record">
        <a-tooltip>
          <template slot="title">
            <div>采购订单：{{ record.purchased_order_inc6 }} 个</div>
            <div>激活订单：{{ record.actived_order_inc6 }} 个</div>
            <div>续期订单：{{ record.renewed_order_inc6 }} 个</div>
            <div>订购订单：{{ record.subscribed_order_inc6 }} 个</div>
            <div>套餐停机保号订单：{{ record.stopped_order_inc6 }} 个</div>
            <div>流量使用订单：{{ record.card_used_order_inc6 }} 个</div>
          </template>
          <div class="tip-item">
            {{ total_order_inc6 }}
          </div>
        </a-tooltip>
      </div>

      <div slot="totalOrderInc12" slot-scope="total_order_inc12, record">
        <a-tooltip>
          <template slot="title">
            <div>采购订单：{{ record.purchased_order_inc12 }} 个</div>
            <div>激活订单：{{ record.actived_order_inc12 }} 个</div>
            <div>续期订单：{{ record.renewed_order_inc12 }} 个</div>
            <div>套餐订购订单：{{ record.subscribed_order_inc12 }} 个</div>
            <div>停机保号订单：{{ record.stopped_order_inc12 }} 个</div>
            <div>流量使用订单：{{ record.card_used_order_inc12 }} 个</div>
          </template>
          <div class="tip-item">
            {{ total_order_inc12 }}
          </div>
        </a-tooltip>
      </div>
    </a-table>

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />
  </div>
</template>

<script>
import SearchAgentStatistics from '@/views/agent_statistics/Search'
import OrderMonthlyIncChart from '@/views/agent_statistics/OrderMonthlyIncChart'
import Pagination from '@/components/Pagination'
import { hasPermission } from '@/utils/permission'
import { findAgentStatisticsOrder, exportAgentStatisticsOrder } from '@/api/agent_statistics'
import { exportExcel } from '@/api/excel'
export default {
  name: 'AgentStatisticsOrder',
  components: {
    SearchAgentStatistics,
    OrderMonthlyIncChart,
    Pagination
  },
  data() {
    return {
      data: [],
      loading: true,
      pagination: {
        total_count: 0
      },
      query: {},
      sort: {
        sort_field: '',
        sort_order: ''
      }
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    columns() {
      return [
        {
          title: '客户名称',
          dataIndex: 'name',
          fixed: 'left',
          scopedSlots: { customRender: 'name' }
        },
        {
          title: '截止月份',
          dataIndex: 'month'
        },
        {
          title: '累计订单量(个)',
          dataIndex: 'total_order',
          sorter: true,
          sortOrder: this.sort.sort_field === 'total_order' ? this.sort.sort_order : false,
          scopedSlots: { customRender: 'totalOrder' }
        },
        {
          title: '近1月订单量(个)',
          dataIndex: 'total_order_inc1',
          sorter: true,
          sortOrder: this.sort.sort_field === 'total_order_inc1' ? this.sort.sort_order : false,
          scopedSlots: { customRender: 'totalOrderInc1' }
        },
        {
          title: '近3月订单量(个)',
          dataIndex: 'total_order_inc3',
          sorter: true,
          sortOrder: this.sort.sort_field === 'total_order_inc3' ? this.sort.sort_order : false,
          scopedSlots: { customRender: 'totalOrderInc3' }
        },
        {
          title: '近6月订单量(个)',
          dataIndex: 'total_order_inc6',
          sorter: true,
          sortOrder: this.sort.sort_field === 'total_order_inc6' ? this.sort.sort_order : false,
          scopedSlots: { customRender: 'totalOrderInc6' }
        },
        {
          title: '近12月订单量(个)',
          dataIndex: 'total_order_inc12',
          sorter: true,
          sortOrder: this.sort.sort_field === 'total_order_inc12' ? this.sort.sort_order : false,
          scopedSlots: { customRender: 'totalOrderInc12' }
        },
        {
          title: '近1月采购订单量(个)',
          dataIndex: 'purchased_order_inc1',
          sorter: true,
          sortOrder: this.sort.sort_field === 'purchased_order_inc1' ? this.sort.sort_order : false
        },
        {
          title: '近3月采购订单量(个)',
          dataIndex: 'purchased_order_inc3',
          sorter: true,
          sortOrder: this.sort.sort_field === 'purchased_order_inc3' ? this.sort.sort_order : false
        },
        {
          title: '近6月采购订单量(个)',
          dataIndex: 'purchased_order_inc6',
          sorter: true,
          sortOrder: this.sort.sort_field === 'purchased_order_inc6' ? this.sort.sort_order : false
        },
        {
          title: '近12月采购订单量(个)',
          dataIndex: 'purchased_order_inc12',
          sorter: true,
          sortOrder: this.sort.sort_field === 'purchased_order_inc12' ? this.sort.sort_order : false
        },
        {
          title: '责任销售',
          dataIndex: 'sales_full_names'
        }
      ]
    },
    agentId() {
      return parseInt(this.$route.params.id)
    }
  },
  methods: {
    isShowMenu(menu) {
      return hasPermission(menu)
    },

    submitSearch(search) {
      // 重置排序
      this.sort = this.$options.data().sort
      // 赋值搜索条件，保留 per_page
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search)
      this.fetchData()
    },

    sortChange(pagination, filters, sorter) {
      this.sort.sort_field = sorter.field
      this.sort.sort_order = sorter.order
      // 跳转第一页
      this.query.page = 1
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      this.selectedRowKeys = []
      findAgentStatisticsOrder(Object.assign({}, this.query, this.sort)).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }
        this.loading = false
      })
    },

    exportData() {
      exportAgentStatisticsOrder(Object.assign({ agent_id: this.agentId }, this.query)).then((res) => {
        if (res.code === 0 && res.data.is_direct_download === true) {
          exportExcel(res.data.id, res.data.file_name)
        }
      })
    }
  }
}
</script>

<style>
.ant-tooltip {
  max-width: 1010px;
}
</style>
